/**
 * User: nir
 * Date: 06/09/2016
 * Time: 17:42
 */

if (window && window.jQuery) {
  window.jQuery(function($) {
    // define the function
    window.TCT = window.TCT || {};
    window.TCT.loadHDImages = function() {
      var width = $(document).width(),
          props = ['data-hd', 'data-sd'],
          lowResImages = null,
          prop = null;

      if (width >= 768) {
        prop = props[0];
      } else if (width >= 256) {
        prop = props[1];
      }

      if (prop) {
        lowResImages = $('[' + prop + ']');
        lowResImages.each(function() {
          var target = $(this),
              path = target.attr(prop);

          $('<img src="' + path + '">').load(function() {
            target.css('background-image', 'url(' + path + ')');
          });
        });
      }

      for (var i = 0; i < props.length; i++) {
        $('[' + props[i] + ']').removeAttr(props[i]);
      }
    };

    // run on page load
    $(window).on('load', window.TCT.loadHDImages);
  });
}